"use client";

import { Box, Fade } from "@mui/material";
import React from "react";
import { EmblaCarouselType } from "embla-carousel";
import { usePrevNextButtons } from "@/lib/usePrevNextButtons";

function CarouselFadeSides({ emblaApi }: { emblaApi?: EmblaCarouselType }) {
  const { nextBtnDisabled, prevBtnDisabled } = usePrevNextButtons(emblaApi as any);

  return (
    <>
      <Fade in={!nextBtnDisabled}>
        <Box
          sx={(theme) => ({
            position: "absolute",
            display: "flex",
            alignItems: "center",
            right: 0,
            top: 0,
            height: "100%",
            width: { xs: "1%", md: "3%" },
            zIndex: 1,
            background: `linear-gradient(90deg,  ${theme.palette.background.default},transparent)`,
          })}
        ></Box>
      </Fade>
      <Fade in={!prevBtnDisabled}>
        <Box
          sx={(theme) => ({
            position: "absolute",
            display: "flex",
            alignItems: "center",
            left: 0,
            top: 0,
            height: "100%",
            width: { xs: "1%", md: "3%" },
            zIndex: 1,
            background: `linear-gradient(90deg, transparent,  ${theme.palette.background.default})`,
          })}
        ></Box>
      </Fade>
    </>
  );
}

export default React.memo(CarouselFadeSides);
